__webpack_require__.p = "https://bmidxbitalyplpreprod.netlify.app/";